import { frontendURL } from '../../../helper/URLHelper';
const BotsView = () => import('./BotsView.vue');

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/bots'),
      name: 'bots_view',
      component: BotsView,
      meta: {
        permissions: ['administrator', 'agent'],
      },
    },
  ],
};
